import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ErrorService } from '@core/services';

import { LogErrorRequest } from '#types/log';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private errorService: ErrorService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // skip error reports / client logs
        if (req.urlWithParams.match('.*/log/(error|client).*')) {
          return throwError(() => error);
        }

        // skip specific auth endpoints as they handle errors separately
        if (req.urlWithParams.match('.*/auth/(login|logout|ping|change-facility|change-customer).*')) {
          return throwError(() => error);
        }

        if (error.status >= 500) {
          const err: any = error?.error?.error ?? error?.error ?? error ?? {};

          const payload: LogErrorRequest = {
            title: 'Server Error',
            message: err?.message ?? 'Unknown Exception',
            type: err?.type ?? 'server',
            request: {
              statusCode: err?.statusCode ?? 500,
            },
          };

          // handle errors returned by the reverse proxy and not the api
          if (error.status > 500) {
            payload.message = `The request could not be completed: ${error.status} ${error.statusText}`;
            payload.type = 'server';
            payload.request.statusCode = error.status;
          }

          this.errorService
            .serverError(payload, req, error)
            .then()
            .catch((e) => console.error(e));
        }

        return throwError(() => error);
      })
    );
  }
}
